export default __webpack_public_path__ + "static/media/Egg Shaped Image.559e4377.png";